/* eslint-disable prettier/prettier */
/* eslint-disable */

import { connectReducers } from '../../utils';

import { GET_STUDENT_DIAGNOSIS } from '../../actions';

import { FAILURE, REQUEST, SUCCESS } from '../../actions/utils';

import { IDiagnosisResponse } from '../../api/types';

import genericReducers from '../genericReducer';

import { IReducers } from '..';

export type StudentDiagnosisState = IDiagnosisResponse | null;

const initialState: StudentDiagnosisState = null;
const generic = genericReducers<StudentDiagnosisState>();
const studentDiagnosis: IReducers<StudentDiagnosisState> = {
  [GET_STUDENT_DIAGNOSIS[REQUEST]]: generic.get.request,
  [GET_STUDENT_DIAGNOSIS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_DIAGNOSIS[FAILURE]]: generic.get.failure,
};

export default connectReducers(initialState, studentDiagnosis);
